exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".categorieshomepage .specialwidth[data-v-05e2941a]{display:flex;flex:1;width:var(--dynamic-width);box-sizing:border-box}", ""]);

// exports
